import { Header } from "@/components/landing/Header";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { FaqCtaBanner } from "@/components/landing/FaqCtaBanner";
import { Footer } from "@/components/landing/Footer";
import { SeoHead } from "@/components/seo/SeoHead";
import { StructuredData } from "@/components/seo/StructuredData";
import {
  getBaseUrl,
  buildBreadcrumbSchema,
  buildFAQPageSchema,
  buildOrganizationSchema,
  buildSoftwareApplicationSchema,
  buildWebPageSchema,
} from "@/lib/seo";
import { faqs as faqItems } from "@/components/landing/FAQ";

const PLANS_TITLE = "Planos de agente de IA para WhatsApp e Instagram | FabChat";
const PLANS_DESCRIPTION =
  "Compare os planos da FabChat para agente de IA no WhatsApp e Instagram com CRM integrado, automação de atendimento e qualificação de leads.";

const breadcrumbItems = [
  { name: "Início", path: "/" },
  { name: "Planos", path: "/planos" },
];

const Plans = () => {
  const baseUrl = getBaseUrl();
  const breadcrumbSchema = buildBreadcrumbSchema(baseUrl, breadcrumbItems);
  const faqSchema = buildFAQPageSchema(faqItems);
  const organizationSchema = buildOrganizationSchema(baseUrl);
  const softwareSchema = buildSoftwareApplicationSchema(baseUrl, PLANS_DESCRIPTION);
  const webPageSchema = buildWebPageSchema(baseUrl, { path: "/planos", title: PLANS_TITLE, description: PLANS_DESCRIPTION });

  return (
    <div className="min-h-screen flex flex-col">
      <SeoHead
        title={PLANS_TITLE}
        description={PLANS_DESCRIPTION}
        canonicalPath="/planos"
      />
      <StructuredData
        data={[organizationSchema, softwareSchema, breadcrumbSchema, faqSchema, webPageSchema]}
      />
      <Header />
      <main className="flex-1">
        <section className="pt-24 pb-12">
          <div className="container mx-auto px-4 text-center mb-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Escolha o plano ideal para o seu negócio
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Compare os planos e contrate ou faça upgrade do seu plano atual em poucos cliques.
            </p>
          </div>
          <Pricing />
        </section>
        <FAQ />
        <FaqCtaBanner />
      </main>
      <Footer />
    </div>
  );
};

export default Plans;
